/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { catchErrorAsJson } from '@fcom/rx';
import { DapiHttpResponse } from '../../dapi-http-response';
import { DapiRequestBuilder } from '../../dapi-request-builder';

import { FinnairAirBoundsRequest } from '../../models/finnair-air-bounds-request';
import { FinnairAirBoundsResponse } from '../../models/finnair-air-bounds-response';

export interface FindAurinkomatkatAirBounds$Params {
      body: FinnairAirBoundsRequest
}

export function findAurinkomatkatAirBounds(http: HttpClient, rootUrl: string, params: FindAurinkomatkatAirBounds$Params, context?: HttpContext): Observable<DapiHttpResponse<FinnairAirBoundsResponse>> {
  const rb = new DapiRequestBuilder(rootUrl, findAurinkomatkatAirBounds.PATH, 'post');

  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as DapiHttpResponse<FinnairAirBoundsResponse>;
    }),
    catchErrorAsJson()
  );
}

findAurinkomatkatAirBounds.PATH = '/api/am/airBounds';
